import {
  Autocomplete,
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  activeStepState,
  arrivalCountryCodeState,
  arrivalCountryState,
  dimensionArrayState,
  docOrPackModalState,
  documentMaxGrossState,
  overPayDesignState,
  productCurrencyState,
  productValueState,
  senderCreateCountryCodeState,
  senderCreateCountryState,
  senderZipCodeState,
  shipmentDocumentState,
  shipmentPriceArrayState,
  shipmentReceiverCityState,
  shipmentReceiverDistrictState,
  shipmentReceiverStateCodeState,
  shipmentReceiverStateState,
  shipmentSenderCityState,
  shipmentSenderDistrictState,
  shipmentSenderStateCodeState,
  shipmentSenderStateState,
  shipmentZipCodeState,
  isAbove150EURCheckState,
  checkedCustomsState,
  ddpRateState,
  selectedHsOptionState,
  hsCodeFromShipmentInfoState,
  isEtgbState,
} from "../../atoms/createShipment";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import React, { useCallback, useState, useMemo } from "react";
import axios from "../../api/axios";
import CircularProgress from "@mui/material/CircularProgress";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import { useEffect } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CountryRestrictInfo from "./shipmentInfo/CountryRestrictInfo";
import CountriesTurkishSorted from "../../utils/CountriesTurkishSorted";
import { FormatFieldWithTwoDecimals } from "../../utils/FormatField";
import { EngCharUpperCase } from "../../utils/UpperCase";
import iossCountries from "../../json/iossCountries.json";

const ShipmentInfo = () => {
  const member = JSON.parse(localStorage.getItem("user"));
  const memberId = member?.user?.user_member?.id;
  const isTargetUser = memberId === 4000000003 || memberId === "4000000003";

  const europeCountryCodes = useMemo(() => {
    return new Set(iossCountries.map((c) => c.iso_code));
  }, []);

  const [countryRestrictInfo, setCountryRestrictInfo] = useState(false);
  const [productValueError, setProductValueError] = useState(false);
  const [productValueHelperText, setProductValueHelperText] = useState("");

  // HS Code states
  // eslint-disable-next-line no-unused-vars
  const [hsCode, setHsCode] = useState("");
  const [selectedHsOption, setSelectedHsOption] = useRecoilState(
    selectedHsOptionState
  );
  const [hsOptions, setHsOptions] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  const [overPayDesign, setOverPayDesign] = useRecoilState(overPayDesignState);
  const [shipmentDocument, setShipmentDocument] = useRecoilState(
    shipmentDocumentState
  );
  const [arrivalCountry, setArrivalCountry] =
    useRecoilState(arrivalCountryState);
  const [senderCreateCountry, setSenderCreateCountry] = useRecoilState(
    senderCreateCountryState
  );
  const [senderCreateCountryCode, setSenderCreateCountryCode] = useRecoilState(
    senderCreateCountryCodeState
  );
  const [senderZipCode, setSenderZipCode] = useRecoilState(senderZipCodeState);
  const [arrivalCountryCode, setArrivalCountryCode] = useRecoilState(
    arrivalCountryCodeState
  );
  const [productValue, setProductValue] = useRecoilState(productValueState);
  const [productCurrency, setProductCurrency] =
    useRecoilState(productCurrencyState);
  const [documentMaxGross, setDocumentMaxGross] = useRecoilState(
    documentMaxGrossState
  );
  const [shipmentZipCode, setShipmentZipCode] =
    useRecoilState(shipmentZipCodeState);

  const setDimensionArray = useSetRecoilState(dimensionArrayState);
  const setShipmentPriceArray = useSetRecoilState(shipmentPriceArrayState);
  const setActiveStep = useSetRecoilState(activeStepState);
  const setShipmentReceiverState = useSetRecoilState(
    shipmentReceiverStateState
  );
  const setShipmentReceiverDistrict = useSetRecoilState(
    shipmentReceiverDistrictState
  );
  const setShipmentReceiverCity = useSetRecoilState(shipmentReceiverCityState);
  const setShipmentReceiverStateCode = useSetRecoilState(
    shipmentReceiverStateCodeState
  );
  const setShipmentSenderState = useSetRecoilState(shipmentSenderStateState);
  const setShipmentSenderDistrict = useSetRecoilState(
    shipmentSenderDistrictState
  );
  const setShipmentSenderCity = useSetRecoilState(shipmentSenderCityState);
  const setShipmentSenderStateCode = useSetRecoilState(
    shipmentSenderStateCodeState
  );
  const setDocOrPackModal = useSetRecoilState(docOrPackModalState);
  const setIsAbove150EURCheck = useSetRecoilState(isAbove150EURCheckState);
  const setCheckedCustoms = useSetRecoilState(checkedCustomsState);
  const setDdpRate = useSetRecoilState(ddpRateState);
  const setGlobalSelectedHsOption = useSetRecoilState(selectedHsOptionState);
  const setHsCodeFromShipmentInfo = useSetRecoilState(
    hsCodeFromShipmentInfoState
  );
  const [isEtgb, setIsEtgb] = useRecoilState(isEtgbState);

  // Member HS Codes state
  const [memberHsCodes, setMemberHsCodes] = useState([]);
  const [memberHsLoading, setMemberHsLoading] = useState(false);
  const [selectedMemberHsCode, setSelectedMemberHsCode] = useState("");
  const [taxLoading, setTaxLoading] = useState(false);

  // HS Code arama fonksiyonları
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    (() => {
      let timeoutId;
      return (searchTerm) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          searchHsCodes(searchTerm);
        }, 500);
      };
    })(),
    []
  );

  // Autocomplete için arama fonksiyonu
  const searchHsCodes = async (searchTerm) => {
    if (!searchTerm || searchTerm.length <= 2) {
      setHsOptions([]);
      return;
    }

    setSearchLoading(true);
    try {
      const response = await axios.get(`hscode-search/${searchTerm}`);

      if (response.data && !response.data.error) {
        let dataToProcess = null;

        // Yeni API yanıt yapısını kontrol et
        if (response.data.items && Array.isArray(response.data.items)) {
          dataToProcess = response.data.items;
        }
        // Eski formatları da destekle (geriye uyumluluk için)
        else if (response.data.status === 200 && response.data.data) {
          dataToProcess = response.data.data;
        } else if (Array.isArray(response.data)) {
          dataToProcess = response.data;
        } else if (response.data.htsno) {
          dataToProcess = response.data;
        }

        if (
          dataToProcess &&
          Array.isArray(dataToProcess) &&
          dataToProcess.length > 0
        ) {
          // Autocomplete için formatla
          const formattedOptions = dataToProcess
            .filter((item) => item && item.htsno && item.description) // Geçerli verileri filtrele
            .filter((item) => {
              // N/A değerlerini filtrele
              const taxRate = item.general || item.special || item.other;
              return taxRate && taxRate !== "" && taxRate !== "N/A";
            })
            .map((item) => ({
              label: `${item.htsno} - ${item.description}`,
              value: item.htsno,
              data: item,
            }));

          setHsOptions(formattedOptions);
        } else {
          setHsOptions([]);
        }
      } else {
        setHsOptions([]);
      }
    } catch (error) {
      console.error("HS kodu arama hatası:", error);
      setHsOptions([]);
    } finally {
      setSearchLoading(false);
    }
  };

  // Member HS codes'ları getir
  useEffect(() => {
    const fetchMemberHsCodes = async () => {
      setMemberHsLoading(true);
      try {
        const response = await axios.get('member-hs-code');
        if (response.data && response.data.status === 200 && response.data.data) {
          const formatted = response.data.data.map((item) => ({
            label: `${item.hs_code} - ${item.description}`,
            value: item.hs_code,
            data: {
              htsno: item.hs_code,
              description: item.description,
              general: null,
              special: null,
              other: null,
            },
          }));
          setMemberHsCodes(formatted);
        }
      } catch (e) {
        console.error('Member HS codes yükleme hatası:', e);
      } finally {
        setMemberHsLoading(false);
      }
    };

    fetchMemberHsCodes();
  }, []);

  // Member HS kodu seçimi
  const handleMemberHsCodeChange = useCallback(async (e) => {
    const selectedValue = e.target.value;
    setSelectedMemberHsCode(selectedValue);

    const selectedMemberCode = memberHsCodes.find(code => code.value === selectedValue);
    if (!selectedMemberCode) {
      // temizle
      setSelectedHsOption(null);
      setHsOptions([]);
      setDdpRate(null);
      return;
    }

    // Vergi oranını getir ve Autocomplete'i eşitle
    setTaxLoading(true);
    try {
      const response = await axios.get(`hscode-search/${selectedMemberCode.value}`);
      if (response.data && !response.data.error && response.data.items && response.data.items.length > 0) {
        const exactMatch = response.data.items.find(item => item.htsno === selectedMemberCode.value);
        const hsData = exactMatch || response.data.items[0];
        const taxRate = hsData.general || hsData.special || hsData.other;

        let numericRate = null;
        if (taxRate && taxRate !== "" && taxRate !== "N/A") {
          const rate = String(taxRate).toLowerCase();
          if (rate === "free" || rate === "0%" || rate === "0") {
            numericRate = 0;
          } else if (rate.includes("%")) {
            const parsed = parseFloat(rate.replace("%", ""));
            if (!isNaN(parsed)) numericRate = parsed;
          } else if (!isNaN(parseFloat(rate))) {
            numericRate = parseFloat(rate);
          }
        }

        const updatedData = { ...hsData, general: taxRate };
        const hsCodeWithTax = { label: selectedMemberCode.value, value: selectedMemberCode.value, data: updatedData };
        setSelectedHsOption(hsCodeWithTax);
        setHsOptions([hsCodeWithTax]);
        setDdpRate(numericRate);
      } else {
        // API'den veri alınamazsa sadece HS kodu ile devam et
        const hsCodeOnly = { label: selectedMemberCode.value, value: selectedMemberCode.value, data: selectedMemberCode.data };
        setSelectedHsOption(hsCodeOnly);
        setHsOptions([hsCodeOnly]);
        setDdpRate(null);
      }
    } catch (error) {
      console.error("HS kodu vergi oranı alınamadı:", error);
      const hsCodeOnly = { label: selectedMemberCode.value, value: selectedMemberCode.value, data: selectedMemberCode.data };
      setSelectedHsOption(hsCodeOnly);
      setHsOptions([hsCodeOnly]);
      setDdpRate(null);
    } finally {
      setTaxLoading(false);
    }
  }, [memberHsCodes, setSelectedHsOption, setHsOptions, setDdpRate]);

  const handleChangeZipCode = (e) => {
    const value = EngCharUpperCase(e.target.value);
    setShipmentZipCode(value);
  };

  const handleDocOrPack = useCallback(() => {
    setDocOrPackModal(true);
  }, [setDocOrPackModal]);

  const handleSelectCountry = useCallback(
    (e) => {
      setArrivalCountry(e.country_name_tr);
      setArrivalCountryCode(e.iso_code);
      setShipmentZipCode("");
      // Ülke değiştiğinde HS Code seçimini temizle (sadece farklı ülke seçilirse)
      if (e.iso_code !== arrivalCountryCode) {
        setSelectedHsOption(null);
        setHsCode("");
        setHsOptions([]);
        setDdpRate(null);
        setGlobalSelectedHsOption(null);
        setHsCodeFromShipmentInfo("");
      }
    },
    [
      setArrivalCountry,
      setArrivalCountryCode,
      setShipmentZipCode,
      setDdpRate,
      arrivalCountryCode,
      setGlobalSelectedHsOption,
      setHsCodeFromShipmentInfo,
    ]
  );

  const handleSenderCountry = useCallback(
    (e) => {
      setSenderCreateCountry(e.country_name_tr);
      setSenderCreateCountryCode(e.iso_code);
      if (e.iso_code === "DE" && arrivalCountryCode && !europeCountryCodes.has(arrivalCountryCode)) {
        setArrivalCountry("");
        setArrivalCountryCode("");
      }
    },
    [setSenderCreateCountry, setSenderCreateCountryCode, arrivalCountryCode, europeCountryCodes, setArrivalCountry, setArrivalCountryCode]
  );

  const handleDocument = useCallback(
    (e) => {
      setShipmentDocument(e.target.value);
      if (e.target.value === "D") {
        setDimensionArray([]);
        setShipmentPriceArray([]);
        setProductValue("");
      }
    },
    [
      setDimensionArray,
      setShipmentDocument,
      setShipmentPriceArray,
      setProductValue,
    ]
  );

  const handleProductCostChange = (e) => {
    setProductValueError(false);
    setProductValueHelperText(false);
    FormatFieldWithTwoDecimals(e, setProductValue);
  };

  const handleProductCostBlur = useCallback(() => {
    const value = parseFloat(productValue);
    if (value < 1) {
      setProductValueError(true);
      setProductValueHelperText(
        "Bedel olarak en az 1 değerini girebilirsiniz."
      );
    } else {
      setProductValueError(false);
      setProductValueHelperText("");
    }
  }, [productValue]);

  const zipCodeHandler = useCallback(async () => {
    await axios
      .post("get-geo-details", {
        postalcode: shipmentZipCode,
        country: arrivalCountryCode,
      })
      .then((res) => {
        if (res.data.data.postalcodes.length === 0) {
          setShipmentReceiverState("");
          setShipmentReceiverDistrict("");
          setShipmentReceiverCity("");
          setShipmentReceiverStateCode("");
        } else if (res.data.data.postalcodes.length > 1) {
          setShipmentReceiverState("");
          setShipmentReceiverDistrict("");
          setShipmentReceiverCity("");
          setShipmentReceiverStateCode("");
        } else {
          setShipmentReceiverState(res.data.data.postalcodes[0].placeName);
          // setShipmentReceiverDistrict(res.data.data.postalcodes[0].adminName2);
          setShipmentReceiverDistrict(
            res.data.data.postalcodes[0].adminName2
              ? res.data.data.postalcodes[0].adminName2
              : res.data.data.postalcodes[0].placeName
          );
          setShipmentReceiverCity(res.data.data.postalcodes[0].adminName1);
          setShipmentReceiverStateCode(res.data.data.postalcodes[0].adminCode1);
        }
      });
  }, [
    setShipmentReceiverState,
    setShipmentReceiverDistrict,
    setShipmentReceiverCity,
    setShipmentReceiverStateCode,
    arrivalCountryCode,
    shipmentZipCode,
  ]);

  const zipSenderCodeHandler = useCallback(async () => {
    await axios
      .post("get-geo-details", {
        postalcode: senderZipCode,
        country: senderCreateCountryCode,
      })
      .then((res) => {
        if (res.data.data.postalcodes.length === 0) {
          setShipmentSenderState("");
          setShipmentSenderDistrict("");
          setShipmentSenderCity("");
          setShipmentSenderStateCode("");
        } else if (res.data.data.postalcodes.length > 1) {
          setShipmentSenderState("");
          setShipmentSenderDistrict("");
          setShipmentSenderCity("");
          setShipmentSenderStateCode("");
        } else {
          setShipmentSenderState(res.data.data.postalcodes[0].placeName);
          // setShipmentReceiverDistrict(res.data.data.postalcodes[0].adminName2);
          setShipmentSenderDistrict(
            res.data.data.postalcodes[0].adminName2
              ? res.data.data.postalcodes[0].adminName2
              : res.data.data.postalcodes[0].placeName
          );
          setShipmentSenderCity(res.data.data.postalcodes[0].adminName1);
          setShipmentSenderStateCode(res.data.data.postalcodes[0].adminCode1);
        }
      });
  }, [
    setShipmentSenderState,
    setShipmentSenderDistrict,
    setShipmentSenderCity,
    setShipmentSenderStateCode,
    senderCreateCountryCode,
    senderZipCode,
  ]);

  const isDisabled = useMemo(() => {
    if (shipmentDocument === "D") {
      if (
        arrivalCountryCode === "" ||
        documentMaxGross === "" ||
        shipmentZipCode === "" ||
        Number(documentMaxGross) > 2.5 ||
        Number(documentMaxGross) === 0
      ) {
        return true;
      } else return false;
    } else if (shipmentDocument !== "D") {
      if (Number(productValue) < 1) {
        return true;
      } else {
        if (
          arrivalCountryCode === "" ||
          productValue === "" ||
          productCurrency === "" ||
          shipmentZipCode === "" ||
          productValueError ||
          (arrivalCountryCode === "US" && !selectedHsOption) // USA için HS Code zorunlu
        ) {
          return true;
        } else return false;
      }
    }
    return false;
  }, [
    arrivalCountryCode,
    productValueError,
    documentMaxGross,
    productValue,
    productCurrency,
    shipmentDocument,
    shipmentZipCode,
    selectedHsOption,
  ]);

  const shipmentInfoCompleteHandler = (e) => {
    if (e) e.preventDefault();

    if (isDisabled) {
      return;
    } else {
      setOverPayDesign(false);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);

      zipCodeHandler();
      zipSenderCodeHandler();
    }
  };

  const handleCountryInfo = () => {
    setCountryRestrictInfo(true);
  };

  useEffect(() => {
    if (shipmentDocument === "") {
      setShipmentDocument("N");
    }
  }, [shipmentDocument, setShipmentDocument]);

  useEffect(() => {
    setIsAbove150EURCheck(false);
    setCheckedCustoms([]);
  }, [setCheckedCustoms, setIsAbove150EURCheck]);

  // HS Code seçimini korumak için global state'i senkronize et
  useEffect(() => {
    if (selectedHsOption && arrivalCountryCode === "US") {
      setGlobalSelectedHsOption(selectedHsOption);
      setHsCodeFromShipmentInfo(selectedHsOption.value || "");

      // Vergi oranını da güncelle
      if (selectedHsOption.data) {
        const taxRate =
          selectedHsOption.data.general ||
          selectedHsOption.data.special ||
          selectedHsOption.data.other;

        let numericRate = null;
        if (taxRate && taxRate !== "" && taxRate !== "N/A") {
          const rate = taxRate.toLowerCase();
          if (rate === "free" || rate === "0%" || rate === "0") {
            numericRate = 0;
          } else if (rate.includes("%")) {
            const parsedRate = parseFloat(rate.replace("%", ""));
            if (!isNaN(parsedRate)) {
              numericRate = parsedRate;
            }
          } else if (!isNaN(parseFloat(rate))) {
            numericRate = parseFloat(rate);
          }
        }
        setDdpRate(numericRate);
      }
    }
  }, [
    selectedHsOption,
    arrivalCountryCode,
    setGlobalSelectedHsOption,
    setHsCodeFromShipmentInfo,
    setDdpRate,
  ]);

  return (
    <Box className="shipmentInfo">
      <CountryRestrictInfo
        open={countryRestrictInfo}
        setOpen={setCountryRestrictInfo}
      />
      <form
        onSubmit={shipmentInfoCompleteHandler}
        className="shipmentInfo-form-wrapper"
      >
        <FormControl required fullWidth sx={{ maxWidth: 380 }} size="small">
          <InputLabel id="select-document">Gönderi Tipi</InputLabel>
          <Select
            labelId="select-document"
            id="select-simple-document"
            value={shipmentDocument}
            onChange={handleDocument}
            label="Gönderi Tipi"
            required
          >
            <MenuItem value={""}>
              <em>Temizle</em>
            </MenuItem>
            <MenuItem value={"D"}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  color: "var(--info)",
                  fontWeight: 600,
                }}
              >
                <SummarizeOutlinedIcon
                  sx={{ color: "var(--info)", width: "21px", height: "21px" }}
                />{" "}
                Döküman
              </div>
            </MenuItem>
            <MenuItem value={"N"}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  color: "var(--info)",
                  fontWeight: 600,
                }}
              >
                <Inventory2OutlinedIcon
                  sx={{ color: "var(--info)", width: "21px", height: "21px" }}
                />{" "}
                Paket
              </div>
            </MenuItem>
          </Select>
          {shipmentDocument === "" && (
            <div className="form-document-info">
              <ErrorOutlineIcon />{" "}
              <div>
                <span className="form-document-info-text">
                  Döküman mı, Paket mi Seçmeliyim?
                </span>{" "}
                <span
                  onClick={handleDocOrPack}
                  className="form-document-info-detail"
                >
                  Tıkla ve Öğren
                </span>
              </div>
            </div>
          )}
        </FormControl>
        <Divider />
        <div className="shipmentInfo-form">
          <Autocomplete
            id="country-typing-select"
            fullWidth
            size="small"
            sx={{ maxWidth: 380 }}
            options={CountriesTurkishSorted().filter(
              (option) => option.iso_code === "TR" || option.iso_code === "DE"
            )}
            value={
              CountriesTurkishSorted().find(
                (option) => option.iso_code === senderCreateCountryCode
              ) || null
            }
            onChange={(e, val) => {
              if (val) {
                handleSenderCountry(val);
              } else {
                setSenderCreateCountry("");
                setSenderCreateCountryCode("");
              }
            }}
            autoHighlight
            openOnFocus={false}
            getOptionLabel={(option) =>
              `${option.country_name_tr}, ${option.country_name_en}`
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                <img
                  loading="lazy"
                  width="20"
                  src={`https://flagcdn.com/w20/${option?.iso_code?.toLowerCase()}.png`}
                  srcSet={`https://flagcdn.com/w40/${option?.iso_code?.toLowerCase()}.png 2x`}
                  alt=""
                />
                {option.country_name_tr}, {option.country_name_en}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Gönderici Ülke Seçiniz"
                required
                name="unique-country-field"
                value={senderCreateCountry}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "off", // disable autocomplete and autofill
                }}
              />
            )}
          />
          <TextField
            required
            value={senderZipCode}
            onChange={(e) => setSenderZipCode(e.target.value)}
            placeholder="06010"
            fullWidth
            size="small"
            autoComplete="off"
            label="Gönderici Posta Kodu"
            sx={{ maxWidth: 200, visibility: "hidden" }}
          />
        </div>
        <Divider />
        <div className="shipmentInfo-form">
          <Autocomplete
            id="country-typing-select"
            fullWidth
            size="small"
            sx={{ maxWidth: 380 }}
            options={
              senderCreateCountryCode === "DE"
                ? CountriesTurkishSorted().filter((c) =>
                  europeCountryCodes.has(c.iso_code)
                )
                : CountriesTurkishSorted()
            }
            value={
              CountriesTurkishSorted().find(
                (option) => option.iso_code === arrivalCountryCode
              ) || null
            }
            onChange={(e, val) => {
              if (val) {
                handleSelectCountry(val);
              } else {
                setArrivalCountry("");
                setArrivalCountryCode("");
              }
            }}
            autoHighlight
            openOnFocus={false}
            getOptionLabel={(option) =>
              `${option.country_name_tr}, ${option.country_name_en}`
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                <img
                  loading="lazy"
                  width="20"
                  src={`https://flagcdn.com/w20/${option?.iso_code?.toLowerCase()}.png`}
                  srcSet={`https://flagcdn.com/w40/${option?.iso_code?.toLowerCase()}.png 2x`}
                  alt=""
                />
                {option.country_name_tr}, {option.country_name_en}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Alıcı Ülke Seçiniz"
                required
                name="unique-country-field"
                value={arrivalCountry}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "off", // disable autocomplete and autofill
                }}
              />
            )}
          />
          <TextField
            required
            value={shipmentZipCode}
            onChange={handleChangeZipCode}
            placeholder="06010"
            fullWidth
            size="small"
            autoComplete="off"
            label="Alıcı Posta Kodu"
            sx={{ maxWidth: 200 }}
          />
        </div>
        <Divider />
        {shipmentDocument === "D" && (
          <div className="shipmentInfo-form">
            <TextField
              label="Kg"
              size="small"
              required
              autoComplete="off"
              name="d-kg"
              value={documentMaxGross}
              onChange={(e) =>
                FormatFieldWithTwoDecimals(e, setDocumentMaxGross)
              }
              sx={{ maxWidth: 100 }}
              helperText={
                Number(documentMaxGross) > 2.5 ? (
                  <span style={{ color: "red", fontSize: "10px" }}>
                    Maksimum 2.5 kg limiti aşıldı.
                  </span>
                ) : Number(documentMaxGross) === 0 ? (
                  <span style={{ color: "red", fontSize: "10px" }}>
                    Ağırlık değeri 0 kg olamaz.
                  </span>
                ) : (
                  ""
                )
              }
              error={
                Number(documentMaxGross) > 2.5 || Number(documentMaxGross) === 0
              }
            />
          </div>
        )}
        {shipmentDocument === "N" && (
          <>
            <div className="shipmentInfo-form">
              <TextField
                label="Mal Bedeli"
                size="small"
                name="product-cost"
                autoFocus={overPayDesign}
                required
                autoComplete="off"
                value={productValue}
                onChange={handleProductCostChange}
                onBlur={handleProductCostBlur}
                error={productValueError}
                helperText={productValueHelperText}
                sx={{
                  width: 200,
                  WebkitAppearance: "none",
                }}
              />
              <FormControl
                required
                fullWidth
                sx={{ maxWidth: 90, minWidth: 60 }}
                size="small"
              >
                <InputLabel id="select-currency">Döviz</InputLabel>
                <Select
                  labelId="select-currency"
                  id="select-simple-currency"
                  value={productCurrency}
                  onChange={(e) => setProductCurrency(e.target.value)}
                  label="Döviz"
                >
                  <MenuItem value={""}>
                    <em>Temizle</em>
                  </MenuItem>
                  <MenuItem value={"EUR"}>€</MenuItem>
                  <MenuItem value={"USD"}>$</MenuItem>
                  <MenuItem value={"GBP"}>£</MenuItem>
                </Select>
              </FormControl>
              {/* HS Code alanı sadece USA seçildiğinde göster */}
              {arrivalCountryCode === "US" && (
                <>
                  {/* ETGB: aynı satırda, döviz alanının yanında */}
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0px 10px 0px 0px",
                      border: "1px solid #c0c0c0",
                      borderRadius: "4px",
                      backgroundColor: "#fff",
                      minWidth: "50px",
                      justifyContent: "center",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isEtgb === 1}
                          onChange={(e) => setIsEtgb(e.target.checked ? 1 : 0)}
                          size="small"
                          sx={{
                            "&.Mui-checked": {
                              color: "var(--btnBgBlue)",
                            },
                          }}
                        />
                      }
                      label="ETGB"
                      style={{ margin: 0, fontSize: "14px", fontWeight: "500" }}
                    />
                  </div> */}
                </>
              )}

            </div>
            {arrivalCountryCode === "US" && (
              <div style={{ display: "flex", gap: "10px", width: "70%", justifyContent: "space-between" }}>
                <FormControl fullWidth sx={{ maxWidth: 280, minWidth: 240 }} size="small">
                  <InputLabel id="member-hs-select">Kayıtlı HS Kodu</InputLabel>
                  <Select
                    labelId="member-hs-select"
                    id="member-hs-select-simple"
                    value={selectedMemberHsCode}
                    label="Kayıtlı HS Kodu"
                    onChange={handleMemberHsCodeChange}
                    disabled={memberHsLoading}
                  >
                    <MenuItem value="">
                      <em>Seçiniz</em>
                    </MenuItem>
                    {memberHsCodes.map((memberCode) => (
                      <MenuItem key={memberCode.value} value={memberCode.value}>
                        {memberCode.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <div style={{ flex: 1, width: "100px", height: "35px" }}>
                  <Autocomplete
                    fullWidth
                    options={hsOptions}
                    getOptionLabel={(option) => {
                      if (typeof option === "string") return option;
                      return option?.label || option?.value || "";
                    }}
                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                    value={selectedHsOption}
                    onChange={(event, newValue) => {
                      setSelectedHsOption(newValue);
                      if (newValue && newValue.data) {
                        const taxRate = newValue.data.general || newValue.data.special || newValue.data.other;
                        let numericRate = null;
                        if (taxRate && taxRate !== "" && taxRate !== "N/A") {
                          const rate = taxRate.toLowerCase();
                          if (rate === "free" || rate === "0%" || rate === "0") {
                            numericRate = 0;
                          } else if (rate.includes("%")) {
                            const parsedRate = parseFloat(rate.replace("%", ""));
                            if (!isNaN(parsedRate)) numericRate = parsedRate;
                          } else if (!isNaN(parseFloat(rate))) {
                            numericRate = parseFloat(rate);
                          }
                        }
                        setDdpRate(numericRate);
                      } else {
                        setDdpRate(null);
                      }
                    }}
                    onInputChange={(event, newInputValue) => {
                      setHsCode(newInputValue);
                      debouncedSearch(newInputValue);
                    }}
                    loading={searchLoading}
                    loadingText="Aranıyor..."
                    noOptionsText="Sonuç bulunamadı"
                    filterOptions={(options) => options}
                    size="small"
                    renderOption={(props, option) => (
                      <li {...props} key={option.value}>
                        <div>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <strong>{option.data?.htsno} </strong>
                            <div style={{ whiteSpace: "nowrap" }}>
                              <span style={{ fontSize: "0.8em", color: "#666" }}> Vergisi: </span>
                              <span style={{ color: "#d32f2f", fontWeight: "bold", fontSize: "0.9em" }}>
                                {option.data?.general || option.data?.special || option.data?.other || "N/A"}
                              </span>
                            </div>
                          </div>
                          <span style={{ fontSize: "0.9em", color: "#666" }}>{option.data?.description}</span>
                        </div>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="HS Kodu veya Ürün Adı (İngilizce)"
                        placeholder="HS Kodu ile Ara..."
                        variant="outlined"
                        size="small"
                        required
                        helperText={
                          <>
                            {arrivalCountryCode === "US" && (
                              <a
                                rel="noreferrer"
                                href="https://uygulama.gtb.gov.tr/Tara/"
                                target="_blank"
                                tabIndex={-1}
                                style={{ fontSize: "inherit", color: "var(--btnBgBlue)" }}
                              >
                                ABD gönderileri için HS Kodu zorunludur. GTIP - HSCODE sorgula
                              </a>
                            )}
                          </>
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {searchLoading ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </div>

                {selectedHsOption && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#f5f5f5",
                      borderRadius: "4px",
                      border: "1px solid #e0e0e0",
                      minWidth: "150px",
                    }}
                  >
                    <div style={{ whiteSpace: "nowrap" }}>
                      <span style={{ fontSize: "14px", color: "#666" }}>Gümrük vergisi: </span>
                      <span style={{ color: "#d32f2f", fontWeight: "bold", fontSize: "16px" }}>
                        {selectedHsOption.data?.general || selectedHsOption.data?.special || selectedHsOption.data?.other || "N/A"}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            )}
            <Button
              onClick={handleCountryInfo}
              className="iyzi-button"
              sx={{
                width: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              <InfoOutlinedIcon />{" "}
              <span style={{ fontSize: "12px" }}>
                Gümrük Muafiyet Limitleri
              </span>
            </Button>
          </>
        )}
        <Button
          sx={{ height: 40, ":disabled": { opacity: 0.4 } }}
          type="submit"
          className="iyzi-button-blue"
          disabled={isDisabled}
        >
          İlerle
        </Button>
      </form>
    </Box>
  );
};

export default ShipmentInfo;
